/**
 * Anonymous, opaque device identifier — generated client-side, stored in
 * localStorage. No PII, just a random UUID-style string used to thread
 * anonymous lite-assessment history together server-side.
 *
 * Cleared when the visitor clicks Reset on the PortfolioRadar (so the same
 * person can start fresh if they want to).
 */
const KEY = "ekselens.deviceId";

const randHex = (len) => {
  const arr = new Uint8Array(len);
  if (typeof window !== "undefined" && window.crypto?.getRandomValues) {
    window.crypto.getRandomValues(arr);
  } else {
    for (let i = 0; i < len; i++) arr[i] = Math.floor(Math.random() * 256);
  }
  return Array.from(arr, (b) => b.toString(16).padStart(2, "0")).join("");
};

export function getDeviceId() {
  try {
    let id = localStorage.getItem(KEY);
    if (!id || id.length < 16) {
      id = "dev_" + randHex(12);
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch (e) {
    // SSR / private-browsing / quota — caller treats null as "anonymous".
    if (typeof console !== "undefined") console.warn("[deviceId] get failed:", e);
    return null;
  }
}

export function clearDeviceId() {
  try {
    localStorage.removeItem(KEY);
  } catch (e) {
    if (typeof console !== "undefined") console.warn("[deviceId] clear failed:", e);
  }
}
